export enum PatchesColumnIndexes {
  PATCH_NAME = 0,
  CVE_COUNT = 1,
  CATEGORY = 2,
  PRODUCTS_COUNT = 3,
}

export enum PatchesColumnKeys {
  PATCH_NAME = 'name',
  CVE_COUNT = 'cveCount',
  CATEGORY = 'patchType',
  PRODUCTS_COUNT = 'productsCount',
}

export interface PatchesGridItem {
  name: string;
  cveCount: number;
  patchType: number;
  productsCount: number;
  patchId: string;
}

export interface GetPatchesGridItems {
  rawEvents?: Array<PatchesGridItem>;
}

export enum PatchesGridEvents {
  SELECT_ROWS = 'patchesGridSelectRows',
  ROW_CLICKED = 'patchesGridRowClicked',
}

export interface PatchRecord {
  _id: string;
  patchId: string;
  name: string;
  patchType: number;
  cveCount: number;
  productsCount: number;
  releaseDate: string;
  uninstallable: boolean;
  os: number;
}

export interface GetMissingPatchesResponse {
  success: boolean;
  records: Array<PatchRecord>;
  total: number;
}
